<template>
    <div class="chat-button-container" :class="{ 'alert': hasNewMessages }" >
        <div 
            class="chat-button-alert" 
            v-show="showAlert" 
            @click="toggleChatWindow" 
            @keyup.enter="toggleChatWindow" 
            @keyup.space="toggleChatWindow" 
            tabindex="0"
            :title="$gettext('Tienes nuevos mensajes - Click para abrir chat')"
            :style="config ? { backgroundColor: config.background_color + ' !important' }: {}">
            <p>{{ $gettext("¡Tienes nuevos mensajes!")}}</p>
        </div>
        <button 
            @click="toggleChatWindow" 
            @keyup.enter="toggleChatWindow" 
            @keyup.space="toggleChatWindow" 
            :aria-label="$gettext('Abrir chat')"
            :title="$gettext('Abrir ventana de chat')"
            id="chatButton"
            :class="{ 'active': isActive, 'bounce': isBounce }" 
            :style="config ? { backgroundColor: config.background_color + ' !important' }: {}" 
            tabindex="0">
        </button>
    </div>
</template>

<script>
import {mapMutations, mapActions, mapState, mapGetters} from 'vuex';

export default {
    name: 'ChatButton',
    data() {
        return {
            showAlert: false
        };
    },
    methods: {
        ...mapMutations(["setChatOpen", "changeBounce"]),
        ...mapActions(['closeCurrentChat']),
        toggleChatWindow() {
            this.setChatOpen(true);
            this.changeBounce(false);
            this.$store.commit('setHasNewMessages', false);
            // Clear any blocked-access banner when the user reopens the widget.
            this.$store.commit('setAccessBlockedMessage', null);
        }
    },
    computed: {
        ...mapState(['isChatOpened', 'chatWindowStatus', 'bounce', 'hasNewMessages']),
        ...mapGetters(['config']),
        isActive() {
            return this.isChatOpened;
        },
        isBounce() {
            return !this.isActive && this.chatWindowStatus === 3 && this.bounce;
        }
    },
    watch: {
        hasNewMessages(value) {
            if (value && !this.isChatOpened && this.chatWindowStatus === 3) {
                this.showAlert = true;
                this.changeBounce(true);
                setTimeout(() => {
                    this.showAlert = false;
                    this.changeBounce(false);
                }, 3000);
            }
        }
    },
    created() {
        this.$store.commit('setHasNewMessages', false);
    }
}
</script>
